/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the selection mode to use for the grid.
 */
export var GridSelectionBehavior = /*@__PURE__*/ (function (GridSelectionBehavior) {
    /**
     * Rows and cells are selected using a toggleable behavior. Modifier selection is ignored (CTRL and SHIFT).
     */
    GridSelectionBehavior[GridSelectionBehavior["Toggle"] = 0] = "Toggle";
    /**
     * Only one row or cell is selected at a time and modifier keys are required to multi-select them.
     */
    GridSelectionBehavior[GridSelectionBehavior["ModifierBased"] = 1] = "ModifierBased";
    return GridSelectionBehavior;
})({});
/**
 * @hidden
 */
export var GridSelectionBehavior_$type = /*@__PURE__*/ markEnum('GridSelectionBehavior', 'Toggle,0|ModifierBased,1');
//# sourceMappingURL=GridSelectionBehavior.js.map
